import React from "react";
import OfferEditorCommon from "./OfferEditorCommon";

/*
 * Stage 1 - Hiring Manager
 *
 * Access is decided in OffersList using:
 * current_stage === 1 &&
 * stage1_email === logged-in email
 *
 * Returned Stage-2 flow:
 * Stage 2 -> Stage 1 -> Edit -> Update Offer & Send -> Stage 2
 *
 * The editable field list is NOT declared here. It is passed in as
 * `editableFields` from OffersList, which always supplies
 * EDITABLE_FIELDS.hiring_manager — the same list the backend enforces via
 * EDITABLE_FIELDS[editorRole]. A local copy would be silently overridden by
 * the `{...props}` spread and would drift from the real policy, so there is
 * exactly one place to change it.
 */

export default function HiringManagerOfferEditor(props) {
  return (
    <OfferEditorCommon
      {...props}
      title="Edit Offer - Hiring Manager"
      stageLabel="Stage 1 - Hiring Manager"
      showAllFields={true}
      note="Only the fields assigned to Stage 1 are editable. Candidate, workflow, BU Head and HR-controlled fields are read-only."
    />
  );
}
